import React, { Component, Fragment } from "react";
import { Modal, Tabs, Button, Badge } from "antd";
import { connect } from "react-redux";
import { Route, Link } from "react-router-dom";
import "./Executorship.css";

// Зависимые контейнеры
import Orders from "./Order/containers/Orders/Orders";
import Requests from "./Request/containers/Requests/Requests";
import Offers from "./Offer/containers/Offers/Offers";

import { interfaceActions } from "../../common/redux/actions";
import * as URLs from "../../common/constants/systemUrls";

import * as requestsActions from "./Request/redux/actions/requests";
import * as ordersActions from "./Order/redux/actions/orders";
import * as offersActions from "./Offer/redux/actions/offers";
import { IconQuestion } from "../../common/ui/icons";
import FreightOrderModal from "./Order/components/Orders/OrderFreightModal/OrderFreightModal";
const { getAllOffers } = offersActions;
const { getAllOrders } = ordersActions;
const { getAllRequests } = requestsActions;

const { setCaption } = interfaceActions;

const { TabPane } = Tabs;

function getLastPathSegment(path) {
  let segments = path.split("/");
  return segments[segments.length - 1];
}

export const getSortObjectBySorter = sorter => {
  let sort = {};

  if (sorter.column) {
    let order = "desc";

    if (sorter.order === "ascend") {
      order = "asc";
    }

    let key = sorter.field;

    switch (key) {
      case "info":
        key = "number";
        break;
      case "state":
        key = "status";
        break;
      case "passengers":
        key = "passengers_count";
        break;
      case "routeLength":
        key = "length";
        break;
      case "dateApplication":
        key = "arrival_datetime";
        break;
      default:
        break;
    }

    sort["sort[" + key + "]"] = order;
  }

  return sort;
};

class Executorship extends Component {
  componentDidMount() {
    this.props.setCaption({
      enabled: true,
      mainCaption: "Исполнительство",
      breadCrumbs: [
        { path: "/" + URLs.CONTROL_PANEL, breadcrumbName: "Панель управления" },
        { path: "/" + URLs.EXECUTORSHIP, breadcrumbName: "Исполнительство" }
      ]
    });
    this.props.getAllOffers();
    this.props.getAllOrders();
    this.props.getAllRequests();
  }

  state = {
    visibleFreightModal: false
  };

  onTabsChange = key => {
    let { match, history } = this.props;

    switch (key) {
      case "order": {
        history.push(match.path + "/order");
        break;
      }
      case "request":
        history.push(match.path + "/request");
        break;
      case "offer":
        history.push(match.path + "/offer");
        break;
      default:
        break;
    }
  };

  showFreightModal = () => {
    this.setState({
      visibleFreightModal: true
    });
  };

  hideFreightModal = () => {
    this.setState({
      visibleFreightModal: false
    });
  };

  render() {
    let { match, location, history } = this.props;

    return (
      <div id="executorship" className="basicForm">
        {location.pathname === "/executorship/order" ? (
          <div className="orders__buttons">
            <Button
              className="orders__buttons-create"
              type="primary"
              style={{ width: 194, marginLeft: 16 }}
              size="large"
              onClick={this.showFreightModal}
            >
              Сформировать Заказ
            </Button>
            <FreightOrderModal
              onCancel={this.hideFreightModal}
              visible={this.state.visibleFreightModal}
              onClickYes={() => {
                history.push("/" + URLs.ORDER_CREATE_WITHOUT_FREIGHT);
              }}
              onClickNo={() => {
                history.push("/" + URLs.ORDER_CREATE);
              }}
            />
          </div>
        ) : null}
        <Tabs
          type="card"
          activeKey={getLastPathSegment(location.pathname)}
          onChange={this.onTabsChange}
        >
          <TabPane
            tab={
              <Fragment>
                <span>Заказы</span>
                <Badge
                  style={{
                    background: "#00A8FF"
                  }}
                  count={
                    this.props.watchedStatOrders &&
                    this.props.watchedStatOrders.unwatched
                  }
                />
              </Fragment>
            }
            key="order"
          >
            <Route
              path={match.path + "/order"}
              render={props => <Orders {...props} />}
            />
          </TabPane>
          <TabPane
            tab={
              <Fragment>
                <span>Заявки</span>
                <Badge
                  style={{
                    background: "#00A8FF"
                  }}
                  count={
                    this.props.watchedStatRequests &&
                    this.props.watchedStatRequests[1].count
                  }
                />
              </Fragment>
            }
            key="request"
          >
            <Route
              path={match.path + "/request"}
              render={props => <Requests {...props} />}
            />
          </TabPane>
          <TabPane
            tab={
              <Fragment>
                <span>Предложения</span>
                <Badge
                  style={{
                    background: "#00A8FF"
                  }}
                />
              </Fragment>
            }
            key="offer"
          >
            <Route
              path={match.path + "/offer"}
              render={props => <Offers {...props} />}
            />
          </TabPane>
        </Tabs>
      </div>
    );
  }
}

export default connect(
  state => ({
    watchedStatRequests: state.Executorship.Requests.requests.watchedTypes,
    watchedStatOrders: state.Executorship.Orders.orders.watchedStat
  }),
  {
    setCaption,
    getAllOffers,
    getAllOrders,
    getAllRequests
  }
)(Executorship);
